export default "__VITE_ASSET__CzfFDq95__"